var exports = {
  "s": "IssueSidePanelContent__4uOUp4",
};

module.exports = exports;
